<!--
 * @Author: Admni
 * @Description: 
 * @Date: 2021-01-13 18:01:47
 * @LastEditTime: 2021-01-14 10:25:07
-->
<template>
  <div class="ci-content" v-if="Info">
    <li>
      用户名称: <span>{{ Info.u_name ? Info.u_name : "" }}</span>
    </li>
    <li>
      用户Ip:
      <span>{{ Info.ip ? Info.ip : "" }}</span>
    </li>
    <li>
      手机系统: <span>{{ Info.os ? Info.os : '' }}</span>
    </li>
    <li>
      设备名字: <span>{{ Info.d_n ? Info.d_n : '' }}</span>
    </li>
    <li>
      分组: <span>{{ Info.g ? Info.g : '' }}</span>
    </li>
    <li>
      设备Id: <span>{{ Info.d ? Info.d : '' }}</span>
    </li>
    <li>
      包名: <span>{{ Info.p ? Info.p : '' }}</span>
    </li>
    <li>
      客服Id: <span>{{ Info.s_id ? Info.s_id : '' }}</span>
    </li>
    <li>
      国家: <span>{{ Info.ctr ? Info.ctr : '' }}</span>
    </li>
    <li>
      用户等级: <span>{{ Info.u_level ? Info.u_level : '' }}</span>
    </li>
    <li>
      版本: <span>{{ Info.ver ? Info.ver : '' }}</span>
    </li>
    <li>
      用户手机国家: <span>{{ Info.s_ctr ? Info.s_ctr : "" }}</span>
    </li>
    <li>
      用户手机型号: <span>{{ Info.dev_mode ? Info.dev_mode : "" }}</span>
    </li>
    <li>
      用户手机语言: <span>{{ Info.os_lang ? Info.os_lang : "" }}</span>
    </li>
    <li>
      会话开始时间:
      <span>{{ Info.s_st ? Info.s_st : "" }}</span>
    </li>
    <li>
      标签:
      <span v-for="(item, index) in Info.tags" :key="index">
          {{item.name}}
      </span>
    </li>
    <li>
      额外信息:
      <span>{{ Info.e_i ? Info.e_i : "" }}</span>
    </li>
  </div>
</template>

<script>
export default {
  props: ["Info"],
};
</script>

<style lang="scss" scoped>
.ci-content {
  ul {
    margin: 0;
    padding: 20px 20px 40px;
    li {
      margin-bottom: 10px;
      list-style: none;
      font-size: 14px;
      line-height: 21px;
      color: #333333;
    }
    li:last-child {
      margin-bottom: 0;
    }
  }
}
</style>